import { useState, useEffect } from "react";
import { directionService } from "../services/directionService";

/**
 * Hook to detect and track the current text direction (LTR/RTL)
 * Syncs with the directionService and document.body.dir
 */
export const useDirection = () => {
  const [dir, setDir] = useState<"ltr" | "rtl">(
    (document.body.dir as "ltr" | "rtl") || "ltr"
  );

  useEffect(() => {
    // Subscribe to direction changes
    const subscription = directionService.getDirectionChange().subscribe(() => {
      const newDir = (document.body.dir as "ltr" | "rtl") || "ltr";
      setDir(newDir);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const isRTL = dir === "rtl";

  return { dir, isRTL };
};
